import React, { lazy } from 'react';
import { useLanguage } from './LanguageContext';
import { MapPin, Phone, Navigation } from 'lucide-react';
export function Location() {
  const {
    t
  } = useLanguage();
  return <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 h-full flex flex-col" data-id="element-159">
      <h3 className="text-2xl font-bold text-brand-deep mb-6" data-id="element-160">
        {t('location.title')}
      </h3>

      <div className="space-y-6 mb-8" data-id="element-161">
        <div className="flex items-start gap-4" data-id="element-162">
          <div className="w-10 h-10 rounded-full bg-brand-light flex items-center justify-center flex-shrink-0 text-brand-teal" data-id="element-163">
            <MapPin className="w-5 h-5" data-id="element-164" />
          </div>
          <div data-id="element-165">
            <p className="font-semibold text-gray-900" data-id="element-166">
              Reading Behavioral Health Center
            </p>
            <p className="text-gray-600" data-id="element-167">40 S 5th St</p>
            <p className="text-gray-600" data-id="element-168">Reading, PA 19602</p>
          </div>
        </div>

        <div className="flex items-start gap-4" data-id="element-169">
          <div className="w-10 h-10 rounded-full bg-brand-light flex items-center justify-center flex-shrink-0 text-brand-teal" data-id="element-170">
            <Phone className="w-5 h-5" data-id="element-171" />
          </div>
          <div data-id="element-172">
            <p className="font-semibold text-gray-900" data-id="element-173">Phone</p>
            <a href="tel:6103747035" className="text-brand-teal hover:text-brand-deep font-medium transition-colors" data-id="element-174">
              (610) 374-7035
            </a>
          </div>
        </div>
      </div>

      <div className="flex-grow rounded-xl overflow-hidden shadow-inner border border-gray-200 min-h-[200px] mb-6" data-id="element-175">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3056.417865768285!2d-75.92983692346618!3d40.33475897145244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c670ca55555555%3A0x5555555555555555!2s40%20S%205th%20St%2C%20Reading%2C%20PA%2019602!5e0!3m2!1sen!2sus!4v1708540000000!5m2!1sen!2sus" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Map location" data-id="element-176"></iframe>
      </div>

      <div className="grid grid-cols-2 gap-4" data-id="element-177">
        <a href="https://maps.google.com/?q=40+S+5th+St,+Reading,+PA+19602" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-white border border-gray-200 hover:border-brand-teal text-gray-700 hover:text-brand-teal py-3 rounded-xl font-medium transition-all" data-id="element-178">
          <Navigation className="w-4 h-4" data-id="element-179" />
          {t('location.directions')}
        </a>
        <a href="tel:6103747035" className="flex items-center justify-center gap-2 bg-brand-teal hover:bg-brand-deep text-white py-3 rounded-xl font-medium transition-all" data-id="element-180">
          <Phone className="w-4 h-4" data-id="element-181" />
          {t('location.call')}
        </a>
      </div>
    </div>;
}